<template>
  <div
    class="flex flex-col items-center gap-xs py-sm"
    id="arende-management-loading"
    v-if="arendeStore.arenden.isLoading || arendeStore.arende.isLoading"
  >
    <SmallSpinner />
    <span>{{
      arendeStore.arenden.isLoading ? "Laddar ärenden..." : "Ärendet laddas..."
    }}</span>
  </div>
  <ClosedArende v-else-if="selectedArende.data?.isOpen === false" />
  <EditArende v-else-if="selectedArende.data?.isOpen === true" />
  <template v-else>
    <h2 class="type-heading-md mb-md">Ärendehantering</h2>
    <avtalat-tabs
      v-model:selected="selectedTab"
      :tabs="[
        {
          name: 'Nytt ärende',
          id: Tab.NewArende,
        },
        {
          name: `Tidigare ärenden (${arendeStore.arendenCount})`,
          id: Tab.ArendenList,
        },
      ]"
    >
      <avtalat-tabs-item :id="Tab.NewArende">
        <ArendeForm />
      </avtalat-tabs-item>
      <avtalat-tabs-item :id="Tab.ArendenList">
        <AllArenden />
      </avtalat-tabs-item>
    </avtalat-tabs>
  </template>
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, provide, ref, watch } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { Anstalldarende } from "@/composables/KundserviceAppApiClient";
import { useApi } from "@/composables/useApi";
import { useNavigation } from "@/composables/useNavigation";

import { useAnstalldarendeStore } from "../store";
import AllArenden from "./AllArenden.vue";
import ArendeForm from "./ArendeForm.vue";
import ClosedArende from "./closed-arende/ClosedArende.vue";
import EditArende from "./edit-arende/EditArende.vue";

enum Tab {
  NewArende = "new-arende",
  ArendenList = "arenden-list",
}

const apiClient = useApi();
const arendeStore = useAnstalldarendeStore();
const navigation = useNavigation();
const selectedTab = ref(Tab.NewArende);
const selectedArende = computed(() => {
  return arendeStore.arende;
});

const props = defineProps<{
  individId: string;
}>();

onMounted(async () => {
  await loadArenden();

  if (arendeStore.arenden.data.filter((t) => t.isOpen).length > 0) {
    selectedTab.value = Tab.ArendenList;
  }
});

watch(
  () => navigation.currentRoute.query,
  () => {
    if (navigation.currentRoute.query.ticket_id) {
      arendeStore.fetchArende(
        parseInt(navigation.currentRoute.query.ticket_id as string),
        apiClient,
      );
    } else {
      arendeStore.arende.data = null;
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  arendeStore.$reset();
});

provide("openArende", (arende: Anstalldarende) => {
  if (!arende?.id) return;
  navigation.openArendeView(arende.id);
});

provide("openArendenAndReload", () => {
  selectedTab.value = Tab.ArendenList;
  loadArenden();
});

async function loadArenden() {
  await arendeStore.fetchArenden(props.individId, apiClient);
}
</script>
